import { useMemo } from 'react';
import useAlarms, {
  IUseAlarmsProps,
} from '../../../../../../../../redux/alarm/hooks/useAlarms';

export const LOW_TEMP_ALARM_EVENT = ['LowValuePb1', 'undertemp'];
const LOW_TEMP_EVENT_IDS = JSON.stringify(LOW_TEMP_ALARM_EVENT);
export function useLowTempAlarms(props: IUseAlarmsProps) {
  const params = useMemo(
    () => ({
      ...props.params,
      event_ids: LOW_TEMP_EVENT_IDS,
    }),
    [props.params]
  );
  const response = useAlarms({
    ...props,
    params,
  });
  const filteredResponse = useMemo(() => {
    const data = response.data?.filter((alarm) =>
      LOW_TEMP_ALARM_EVENT.includes(alarm.event ?? '')
    );
    return {
      ...response,
      data,
      count: data?.length,
    };
  }, [response]);
  return filteredResponse;
}

export default useLowTempAlarms;
